/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * Artic
 * The Artic API documentation
 * OpenAPI spec version: 1.0
 */
import {
  useMutation,
  useQuery,
  useSuspenseQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
  UseSuspenseQueryOptions,
  UseSuspenseQueryResult
} from '@tanstack/react-query';

import type {
  ImportWorkOrderDrawingAssignmentDto,
  JobCardRowDto,
  PartnerWorkOrderRowDto,
  ReorderManufacturingSequenceDto,
  ReorderManufacturingSequenceResponseDto,
  TagMigrationEnqueuedResponseDto,
  UpdateWorkOrdersDrawingsDto,
  WatchtowerUpdateWorkOrdersDto,
  WorkOrderImportValidationDto,
  WorkOrderStatusTransitionDto,
  WorkOrderStatusTransitionResponseDto,
  WorkOrdersControllerGetWorkOrderProgressParams
} from '.././schemas';

import { customFetch } from '../../custom-fetch';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



export type workOrdersControllerWatchtowerUpdateWorkOrdersResponse201 = {
  data: void
  status: 201
}
    
export type workOrdersControllerWatchtowerUpdateWorkOrdersResponseSuccess = (workOrdersControllerWatchtowerUpdateWorkOrdersResponse201) & {
  headers: Headers;
};
;

export type workOrdersControllerWatchtowerUpdateWorkOrdersResponse = (workOrdersControllerWatchtowerUpdateWorkOrdersResponseSuccess)

export const getWorkOrdersControllerWatchtowerUpdateWorkOrdersUrl = () => {


  

  return `/work-orders/watchtower-update`
}

export const workOrdersControllerWatchtowerUpdateWorkOrders = async (watchtowerUpdateWorkOrdersDto: WatchtowerUpdateWorkOrdersDto, options?: RequestInit): Promise<workOrdersControllerWatchtowerUpdateWorkOrdersResponse> => {
  
  return customFetch<workOrdersControllerWatchtowerUpdateWorkOrdersResponse>(getWorkOrdersControllerWatchtowerUpdateWorkOrdersUrl(),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      watchtowerUpdateWorkOrdersDto,)
  }
);}




export const getWorkOrdersControllerWatchtowerUpdateWorkOrdersMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof workOrdersControllerWatchtowerUpdateWorkOrders>>, TError,{data: WatchtowerUpdateWorkOrdersDto}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof workOrdersControllerWatchtowerUpdateWorkOrders>>, TError,{data: WatchtowerUpdateWorkOrdersDto}, TContext> => {

const mutationKey = ['workOrdersControllerWatchtowerUpdateWorkOrders'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof workOrdersControllerWatchtowerUpdateWorkOrders>>, {data: WatchtowerUpdateWorkOrdersDto}> = (props) => {
          const {data} = props ?? {};

          return  workOrdersControllerWatchtowerUpdateWorkOrders(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type WorkOrdersControllerWatchtowerUpdateWorkOrdersMutationResult = NonNullable<Awaited<ReturnType<typeof workOrdersControllerWatchtowerUpdateWorkOrders>>>
    export type WorkOrdersControllerWatchtowerUpdateWorkOrdersMutationBody = WatchtowerUpdateWorkOrdersDto
    export type WorkOrdersControllerWatchtowerUpdateWorkOrdersMutationError = unknown

    export const useWorkOrdersControllerWatchtowerUpdateWorkOrders = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof workOrdersControllerWatchtowerUpdateWorkOrders>>, TError,{data: WatchtowerUpdateWorkOrdersDto}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof workOrdersControllerWatchtowerUpdateWorkOrders>>,
        TError,
        {data: WatchtowerUpdateWorkOrdersDto},
        TContext
      > => {

      const mutationOptions = getWorkOrdersControllerWatchtowerUpdateWorkOrdersMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    export type workOrdersControllerUpdateDrawingsResponse201 = {
  data: void
  status: 201
}
    
export type workOrdersControllerUpdateDrawingsResponseSuccess = (workOrdersControllerUpdateDrawingsResponse201) & {
  headers: Headers;
};
;

export type workOrdersControllerUpdateDrawingsResponse = (workOrdersControllerUpdateDrawingsResponseSuccess)

export const getWorkOrdersControllerUpdateDrawingsUrl = () => {


  

  return `/work-orders/update-drawings`
}

export const workOrdersControllerUpdateDrawings = async (updateWorkOrdersDrawingsDto: UpdateWorkOrdersDrawingsDto, options?: RequestInit): Promise<workOrdersControllerUpdateDrawingsResponse> => {
  
  return customFetch<workOrdersControllerUpdateDrawingsResponse>(getWorkOrdersControllerUpdateDrawingsUrl(),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      updateWorkOrdersDrawingsDto,)
  }
);}




export const getWorkOrdersControllerUpdateDrawingsMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof workOrdersControllerUpdateDrawings>>, TError,{data: UpdateWorkOrdersDrawingsDto}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof workOrdersControllerUpdateDrawings>>, TError,{data: UpdateWorkOrdersDrawingsDto}, TContext> => {

const mutationKey = ['workOrdersControllerUpdateDrawings'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof workOrdersControllerUpdateDrawings>>, {data: UpdateWorkOrdersDrawingsDto}> = (props) => {
          const {data} = props ?? {};

          return  workOrdersControllerUpdateDrawings(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type WorkOrdersControllerUpdateDrawingsMutationResult = NonNullable<Awaited<ReturnType<typeof workOrdersControllerUpdateDrawings>>>
    export type WorkOrdersControllerUpdateDrawingsMutationBody = UpdateWorkOrdersDrawingsDto
    export type WorkOrdersControllerUpdateDrawingsMutationError = unknown

    export const useWorkOrdersControllerUpdateDrawings = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof workOrdersControllerUpdateDrawings>>, TError,{data: UpdateWorkOrdersDrawingsDto}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof workOrdersControllerUpdateDrawings>>,
        TError,
        {data: UpdateWorkOrdersDrawingsDto},
        TContext
      > => {

      const mutationOptions = getWorkOrdersControllerUpdateDrawingsMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    export type workOrdersControllerUpdateDrawingsRevisionsResponse201 = {
  data: void
  status: 201
}
    
export type workOrdersControllerUpdateDrawingsRevisionsResponseSuccess = (workOrdersControllerUpdateDrawingsRevisionsResponse201) & {
  headers: Headers;
};
;

export type workOrdersControllerUpdateDrawingsRevisionsResponse = (workOrdersControllerUpdateDrawingsRevisionsResponseSuccess)

export const getWorkOrdersControllerUpdateDrawingsRevisionsUrl = () => {


  

  return `/work-orders/update-drawings-revisions`
}

export const workOrdersControllerUpdateDrawingsRevisions = async (updateWorkOrdersDrawingsDto: UpdateWorkOrdersDrawingsDto, options?: RequestInit): Promise<workOrdersControllerUpdateDrawingsRevisionsResponse> => {
  
  return customFetch<workOrdersControllerUpdateDrawingsRevisionsResponse>(getWorkOrdersControllerUpdateDrawingsRevisionsUrl(),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      updateWorkOrdersDrawingsDto,)
  }
);}




export const getWorkOrdersControllerUpdateDrawingsRevisionsMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof workOrdersControllerUpdateDrawingsRevisions>>, TError,{data: UpdateWorkOrdersDrawingsDto}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof workOrdersControllerUpdateDrawingsRevisions>>, TError,{data: UpdateWorkOrdersDrawingsDto}, TContext> => {

const mutationKey = ['workOrdersControllerUpdateDrawingsRevisions'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof workOrdersControllerUpdateDrawingsRevisions>>, {data: UpdateWorkOrdersDrawingsDto}> = (props) => {
          const {data} = props ?? {};

          return  workOrdersControllerUpdateDrawingsRevisions(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type WorkOrdersControllerUpdateDrawingsRevisionsMutationResult = NonNullable<Awaited<ReturnType<typeof workOrdersControllerUpdateDrawingsRevisions>>>
    export type WorkOrdersControllerUpdateDrawingsRevisionsMutationBody = UpdateWorkOrdersDrawingsDto
    export type WorkOrdersControllerUpdateDrawingsRevisionsMutationError = unknown

    export const useWorkOrdersControllerUpdateDrawingsRevisions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof workOrdersControllerUpdateDrawingsRevisions>>, TError,{data: UpdateWorkOrdersDrawingsDto}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof workOrdersControllerUpdateDrawingsRevisions>>,
        TError,
        {data: UpdateWorkOrdersDrawingsDto},
        TContext
      > => {

      const mutationOptions = getWorkOrdersControllerUpdateDrawingsRevisionsMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    export type workOrdersControllerImportDrawingsResponse201 = {
  data: void
  status: 201
}
    
export type workOrdersControllerImportDrawingsResponseSuccess = (workOrdersControllerImportDrawingsResponse201) & {
  headers: Headers;
};
;

export type workOrdersControllerImportDrawingsResponse = (workOrdersControllerImportDrawingsResponseSuccess)

export const getWorkOrdersControllerImportDrawingsUrl = () => {


  

  return `/work-orders/import-drawings`
}

export const workOrdersControllerImportDrawings = async (importWorkOrderDrawingAssignmentDto: ImportWorkOrderDrawingAssignmentDto, options?: RequestInit): Promise<workOrdersControllerImportDrawingsResponse> => {
  
  return customFetch<workOrdersControllerImportDrawingsResponse>(getWorkOrdersControllerImportDrawingsUrl(),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      importWorkOrderDrawingAssignmentDto,)
  }
);}




export const getWorkOrdersControllerImportDrawingsMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof workOrdersControllerImportDrawings>>, TError,{data: ImportWorkOrderDrawingAssignmentDto}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof workOrdersControllerImportDrawings>>, TError,{data: ImportWorkOrderDrawingAssignmentDto}, TContext> => {

const mutationKey = ['workOrdersControllerImportDrawings'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof workOrdersControllerImportDrawings>>, {data: ImportWorkOrderDrawingAssignmentDto}> = (props) => {
          const {data} = props ?? {};

          return  workOrdersControllerImportDrawings(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type WorkOrdersControllerImportDrawingsMutationResult = NonNullable<Awaited<ReturnType<typeof workOrdersControllerImportDrawings>>>
    export type WorkOrdersControllerImportDrawingsMutationBody = ImportWorkOrderDrawingAssignmentDto
    export type WorkOrdersControllerImportDrawingsMutationError = unknown

    export const useWorkOrdersControllerImportDrawings = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof workOrdersControllerImportDrawings>>, TError,{data: ImportWorkOrderDrawingAssignmentDto}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof workOrdersControllerImportDrawings>>,
        TError,
        {data: ImportWorkOrderDrawingAssignmentDto},
        TContext
      > => {

      const mutationOptions = getWorkOrdersControllerImportDrawingsMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    export type workOrdersControllerImportWorkOrdersResponse201 = {
  data: void
  status: 201
}
    
export type workOrdersControllerImportWorkOrdersResponseSuccess = (workOrdersControllerImportWorkOrdersResponse201) & {
  headers: Headers;
};
;

export type workOrdersControllerImportWorkOrdersResponse = (workOrdersControllerImportWorkOrdersResponseSuccess)

export const getWorkOrdersControllerImportWorkOrdersUrl = () => {


  

  return `/work-orders/import`
}

export const workOrdersControllerImportWorkOrders = async (workOrderImportValidationDto: WorkOrderImportValidationDto, options?: RequestInit): Promise<workOrdersControllerImportWorkOrdersResponse> => {
  
  return customFetch<workOrdersControllerImportWorkOrdersResponse>(getWorkOrdersControllerImportWorkOrdersUrl(),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      workOrderImportValidationDto,)
  }
);}




export const getWorkOrdersControllerImportWorkOrdersMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof workOrdersControllerImportWorkOrders>>, TError,{data: WorkOrderImportValidationDto}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof workOrdersControllerImportWorkOrders>>, TError,{data: WorkOrderImportValidationDto}, TContext> => {

const mutationKey = ['workOrdersControllerImportWorkOrders'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof workOrdersControllerImportWorkOrders>>, {data: WorkOrderImportValidationDto}> = (props) => {
          const {data} = props ?? {};

          return  workOrdersControllerImportWorkOrders(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type WorkOrdersControllerImportWorkOrdersMutationResult = NonNullable<Awaited<ReturnType<typeof workOrdersControllerImportWorkOrders>>>
    export type WorkOrdersControllerImportWorkOrdersMutationBody = WorkOrderImportValidationDto
    export type WorkOrdersControllerImportWorkOrdersMutationError = unknown

    export const useWorkOrdersControllerImportWorkOrders = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof workOrdersControllerImportWorkOrders>>, TError,{data: WorkOrderImportValidationDto}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof workOrdersControllerImportWorkOrders>>,
        TError,
        {data: WorkOrderImportValidationDto},
        TContext
      > => {

      const mutationOptions = getWorkOrdersControllerImportWorkOrdersMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * Enqueues a background job that copies this work order’s legacy Tag values into Custom Columns (push-only: set/overwritten from the tag, never cleared). A no-op when the work order’s partner has no configured mapping or the target custom column does not exist yet.
 * @summary Backfill custom columns from legacy tags for one work order
 */
export type workOrdersControllerMigrateWorkOrderTagsResponse202 = {
  data: TagMigrationEnqueuedResponseDto
  status: 202
}

export type workOrdersControllerMigrateWorkOrderTagsResponse401 = {
  data: void
  status: 401
}

export type workOrdersControllerMigrateWorkOrderTagsResponse403 = {
  data: void
  status: 403
}
    
export type workOrdersControllerMigrateWorkOrderTagsResponseSuccess = (workOrdersControllerMigrateWorkOrderTagsResponse202) & {
  headers: Headers;
};
export type workOrdersControllerMigrateWorkOrderTagsResponseError = (workOrdersControllerMigrateWorkOrderTagsResponse401 | workOrdersControllerMigrateWorkOrderTagsResponse403) & {
  headers: Headers;
};

export type workOrdersControllerMigrateWorkOrderTagsResponse = (workOrdersControllerMigrateWorkOrderTagsResponseSuccess | workOrdersControllerMigrateWorkOrderTagsResponseError)

export const getWorkOrdersControllerMigrateWorkOrderTagsUrl = (workOrderId: string,) => {


  

  return `/work-orders/${workOrderId}/migrate-tags`
}

export const workOrdersControllerMigrateWorkOrderTags = async (workOrderId: string, options?: RequestInit): Promise<workOrdersControllerMigrateWorkOrderTagsResponse> => {
  
  return customFetch<workOrdersControllerMigrateWorkOrderTagsResponse>(getWorkOrdersControllerMigrateWorkOrderTagsUrl(workOrderId),
  {      
    ...options,
    method: 'POST'
    
    
  }
);}




export const getWorkOrdersControllerMigrateWorkOrderTagsMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof workOrdersControllerMigrateWorkOrderTags>>, TError,{workOrderId: string}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof workOrdersControllerMigrateWorkOrderTags>>, TError,{workOrderId: string}, TContext> => {

const mutationKey = ['workOrdersControllerMigrateWorkOrderTags'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof workOrdersControllerMigrateWorkOrderTags>>, {workOrderId: string}> = (props) => {
          const {workOrderId} = props ?? {};

          return  workOrdersControllerMigrateWorkOrderTags(workOrderId,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type WorkOrdersControllerMigrateWorkOrderTagsMutationResult = NonNullable<Awaited<ReturnType<typeof workOrdersControllerMigrateWorkOrderTags>>>
    
    export type WorkOrdersControllerMigrateWorkOrderTagsMutationError = void

    /**
 * @summary Backfill custom columns from legacy tags for one work order
 */
export const useWorkOrdersControllerMigrateWorkOrderTags = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof workOrdersControllerMigrateWorkOrderTags>>, TError,{workOrderId: string}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof workOrdersControllerMigrateWorkOrderTags>>,
        TError,
        {workOrderId: string},
        TContext
      > => {

      const mutationOptions = getWorkOrdersControllerMigrateWorkOrderTagsMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    export type workOrdersControllerRemoveDrawingsFromWorkOrdersResponse201 = {
  data: void
  status: 201
}
    
export type workOrdersControllerRemoveDrawingsFromWorkOrdersResponseSuccess = (workOrdersControllerRemoveDrawingsFromWorkOrdersResponse201) & {
  headers: Headers;
};
;

export type workOrdersControllerRemoveDrawingsFromWorkOrdersResponse = (workOrdersControllerRemoveDrawingsFromWorkOrdersResponseSuccess)

export const getWorkOrdersControllerRemoveDrawingsFromWorkOrdersUrl = () => {


  

  return `/work-orders/remove-drawings`
}

export const workOrdersControllerRemoveDrawingsFromWorkOrders = async (workOrdersControllerRemoveDrawingsFromWorkOrdersBody: string[], options?: RequestInit): Promise<workOrdersControllerRemoveDrawingsFromWorkOrdersResponse> => {
  
  return customFetch<workOrdersControllerRemoveDrawingsFromWorkOrdersResponse>(getWorkOrdersControllerRemoveDrawingsFromWorkOrdersUrl(),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      workOrdersControllerRemoveDrawingsFromWorkOrdersBody,)
  }
);}




export const getWorkOrdersControllerRemoveDrawingsFromWorkOrdersMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof workOrdersControllerRemoveDrawingsFromWorkOrders>>, TError,{data: string[]}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof workOrdersControllerRemoveDrawingsFromWorkOrders>>, TError,{data: string[]}, TContext> => {

const mutationKey = ['workOrdersControllerRemoveDrawingsFromWorkOrders'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof workOrdersControllerRemoveDrawingsFromWorkOrders>>, {data: string[]}> = (props) => {
          const {data} = props ?? {};

          return  workOrdersControllerRemoveDrawingsFromWorkOrders(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type WorkOrdersControllerRemoveDrawingsFromWorkOrdersMutationResult = NonNullable<Awaited<ReturnType<typeof workOrdersControllerRemoveDrawingsFromWorkOrders>>>
    export type WorkOrdersControllerRemoveDrawingsFromWorkOrdersMutationBody = string[]
    export type WorkOrdersControllerRemoveDrawingsFromWorkOrdersMutationError = unknown

    export const useWorkOrdersControllerRemoveDrawingsFromWorkOrders = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof workOrdersControllerRemoveDrawingsFromWorkOrders>>, TError,{data: string[]}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof workOrdersControllerRemoveDrawingsFromWorkOrders>>,
        TError,
        {data: string[]},
        TContext
      > => {

      const mutationOptions = getWorkOrdersControllerRemoveDrawingsFromWorkOrdersMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    export type workOrdersControllerArchiveWorkOrderResponse200 = {
  data: void
  status: 200
}
    
export type workOrdersControllerArchiveWorkOrderResponseSuccess = (workOrdersControllerArchiveWorkOrderResponse200) & {
  headers: Headers;
};
;

export type workOrdersControllerArchiveWorkOrderResponse = (workOrdersControllerArchiveWorkOrderResponseSuccess)

export const getWorkOrdersControllerArchiveWorkOrderUrl = (workOrderId: string,) => {


  

  return `/work-orders/archive/${workOrderId}`
}

export const workOrdersControllerArchiveWorkOrder = async (workOrderId: string, options?: RequestInit): Promise<workOrdersControllerArchiveWorkOrderResponse> => {
  
  return customFetch<workOrdersControllerArchiveWorkOrderResponse>(getWorkOrdersControllerArchiveWorkOrderUrl(workOrderId),
  {      
    ...options,
    method: 'PATCH'
    
    
  }
);}




export const getWorkOrdersControllerArchiveWorkOrderMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof workOrdersControllerArchiveWorkOrder>>, TError,{workOrderId: string}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof workOrdersControllerArchiveWorkOrder>>, TError,{workOrderId: string}, TContext> => {

const mutationKey = ['workOrdersControllerArchiveWorkOrder'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof workOrdersControllerArchiveWorkOrder>>, {workOrderId: string}> = (props) => {
          const {workOrderId} = props ?? {};

          return  workOrdersControllerArchiveWorkOrder(workOrderId,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type WorkOrdersControllerArchiveWorkOrderMutationResult = NonNullable<Awaited<ReturnType<typeof workOrdersControllerArchiveWorkOrder>>>
    
    export type WorkOrdersControllerArchiveWorkOrderMutationError = unknown

    export const useWorkOrdersControllerArchiveWorkOrder = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof workOrdersControllerArchiveWorkOrder>>, TError,{workOrderId: string}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof workOrdersControllerArchiveWorkOrder>>,
        TError,
        {workOrderId: string},
        TContext
      > => {

      const mutationOptions = getWorkOrdersControllerArchiveWorkOrderMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    export type workOrdersControllerBulkArchiveWorkOrdersResponse200 = {
  data: void
  status: 200
}
    
export type workOrdersControllerBulkArchiveWorkOrdersResponseSuccess = (workOrdersControllerBulkArchiveWorkOrdersResponse200) & {
  headers: Headers;
};
;

export type workOrdersControllerBulkArchiveWorkOrdersResponse = (workOrdersControllerBulkArchiveWorkOrdersResponseSuccess)

export const getWorkOrdersControllerBulkArchiveWorkOrdersUrl = () => {


  

  return `/work-orders/bulk-archive`
}

export const workOrdersControllerBulkArchiveWorkOrders = async ( options?: RequestInit): Promise<workOrdersControllerBulkArchiveWorkOrdersResponse> => {
  
  return customFetch<workOrdersControllerBulkArchiveWorkOrdersResponse>(getWorkOrdersControllerBulkArchiveWorkOrdersUrl(),
  {      
    ...options,
    method: 'PATCH'
    
    
  }
);}




export const getWorkOrdersControllerBulkArchiveWorkOrdersMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof workOrdersControllerBulkArchiveWorkOrders>>, TError,void, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof workOrdersControllerBulkArchiveWorkOrders>>, TError,void, TContext> => {

const mutationKey = ['workOrdersControllerBulkArchiveWorkOrders'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof workOrdersControllerBulkArchiveWorkOrders>>, void> = () => {
          

          return  workOrdersControllerBulkArchiveWorkOrders(requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type WorkOrdersControllerBulkArchiveWorkOrdersMutationResult = NonNullable<Awaited<ReturnType<typeof workOrdersControllerBulkArchiveWorkOrders>>>
    
    export type WorkOrdersControllerBulkArchiveWorkOrdersMutationError = unknown

    export const useWorkOrdersControllerBulkArchiveWorkOrders = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof workOrdersControllerBulkArchiveWorkOrders>>, TError,void, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof workOrdersControllerBulkArchiveWorkOrders>>,
        TError,
        void,
        TContext
      > => {

      const mutationOptions = getWorkOrdersControllerBulkArchiveWorkOrdersMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    export type workOrdersControllerUnarchiveWorkOrderResponse200 = {
  data: void
  status: 200
}
    
export type workOrdersControllerUnarchiveWorkOrderResponseSuccess = (workOrdersControllerUnarchiveWorkOrderResponse200) & {
  headers: Headers;
};
;

export type workOrdersControllerUnarchiveWorkOrderResponse = (workOrdersControllerUnarchiveWorkOrderResponseSuccess)

export const getWorkOrdersControllerUnarchiveWorkOrderUrl = (workOrderId: string,) => {


  

  return `/work-orders/unarchive/${workOrderId}`
}

export const workOrdersControllerUnarchiveWorkOrder = async (workOrderId: string, options?: RequestInit): Promise<workOrdersControllerUnarchiveWorkOrderResponse> => {
  
  return customFetch<workOrdersControllerUnarchiveWorkOrderResponse>(getWorkOrdersControllerUnarchiveWorkOrderUrl(workOrderId),
  {      
    ...options,
    method: 'PATCH'
    
    
  }
);}




export const getWorkOrdersControllerUnarchiveWorkOrderMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof workOrdersControllerUnarchiveWorkOrder>>, TError,{workOrderId: string}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof workOrdersControllerUnarchiveWorkOrder>>, TError,{workOrderId: string}, TContext> => {

const mutationKey = ['workOrdersControllerUnarchiveWorkOrder'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof workOrdersControllerUnarchiveWorkOrder>>, {workOrderId: string}> = (props) => {
          const {workOrderId} = props ?? {};

          return  workOrdersControllerUnarchiveWorkOrder(workOrderId,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type WorkOrdersControllerUnarchiveWorkOrderMutationResult = NonNullable<Awaited<ReturnType<typeof workOrdersControllerUnarchiveWorkOrder>>>
    
    export type WorkOrdersControllerUnarchiveWorkOrderMutationError = unknown

    export const useWorkOrdersControllerUnarchiveWorkOrder = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof workOrdersControllerUnarchiveWorkOrder>>, TError,{workOrderId: string}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof workOrdersControllerUnarchiveWorkOrder>>,
        TError,
        {workOrderId: string},
        TContext
      > => {

      const mutationOptions = getWorkOrdersControllerUnarchiveWorkOrderMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    export type workOrdersControllerGetWorkOrderProgressResponse200 = {
  data: void
  status: 200
}
    
export type workOrdersControllerGetWorkOrderProgressResponseSuccess = (workOrdersControllerGetWorkOrderProgressResponse200) & {
  headers: Headers;
};
;

export type workOrdersControllerGetWorkOrderProgressResponse = (workOrdersControllerGetWorkOrderProgressResponseSuccess)

export const getWorkOrdersControllerGetWorkOrderProgressUrl = (partnerName: string,
    params?: WorkOrdersControllerGetWorkOrderProgressParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/work-orders/progress/${partnerName}?${stringifiedParams}` : `/work-orders/progress/${partnerName}`
}

export const workOrdersControllerGetWorkOrderProgress = async (partnerName: string,
    params?: WorkOrdersControllerGetWorkOrderProgressParams, options?: RequestInit): Promise<workOrdersControllerGetWorkOrderProgressResponse> => {
  
  return customFetch<workOrdersControllerGetWorkOrderProgressResponse>(getWorkOrdersControllerGetWorkOrderProgressUrl(partnerName,params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getWorkOrdersControllerGetWorkOrderProgressQueryKey = (partnerName?: string,
    params?: WorkOrdersControllerGetWorkOrderProgressParams,) => {
    return [
    `/work-orders/progress/${partnerName}`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getWorkOrdersControllerGetWorkOrderProgressQueryOptions = <TData = Awaited<ReturnType<typeof workOrdersControllerGetWorkOrderProgress>>, TError = unknown>(partnerName: string,
    params?: WorkOrdersControllerGetWorkOrderProgressParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof workOrdersControllerGetWorkOrderProgress>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getWorkOrdersControllerGetWorkOrderProgressQueryKey(partnerName,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof workOrdersControllerGetWorkOrderProgress>>> = ({ signal }) => workOrdersControllerGetWorkOrderProgress(partnerName,params, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, enabled: !!(partnerName), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof workOrdersControllerGetWorkOrderProgress>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type WorkOrdersControllerGetWorkOrderProgressQueryResult = NonNullable<Awaited<ReturnType<typeof workOrdersControllerGetWorkOrderProgress>>>
export type WorkOrdersControllerGetWorkOrderProgressQueryError = unknown


export function useWorkOrdersControllerGetWorkOrderProgress<TData = Awaited<ReturnType<typeof workOrdersControllerGetWorkOrderProgress>>, TError = unknown>(
 partnerName: string,
    params: undefined |  WorkOrdersControllerGetWorkOrderProgressParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof workOrdersControllerGetWorkOrderProgress>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof workOrdersControllerGetWorkOrderProgress>>,
          TError,
          Awaited<ReturnType<typeof workOrdersControllerGetWorkOrderProgress>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useWorkOrdersControllerGetWorkOrderProgress<TData = Awaited<ReturnType<typeof workOrdersControllerGetWorkOrderProgress>>, TError = unknown>(
 partnerName: string,
    params?: WorkOrdersControllerGetWorkOrderProgressParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof workOrdersControllerGetWorkOrderProgress>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof workOrdersControllerGetWorkOrderProgress>>,
          TError,
          Awaited<ReturnType<typeof workOrdersControllerGetWorkOrderProgress>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useWorkOrdersControllerGetWorkOrderProgress<TData = Awaited<ReturnType<typeof workOrdersControllerGetWorkOrderProgress>>, TError = unknown>(
 partnerName: string,
    params?: WorkOrdersControllerGetWorkOrderProgressParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof workOrdersControllerGetWorkOrderProgress>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useWorkOrdersControllerGetWorkOrderProgress<TData = Awaited<ReturnType<typeof workOrdersControllerGetWorkOrderProgress>>, TError = unknown>(
 partnerName: string,
    params?: WorkOrdersControllerGetWorkOrderProgressParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof workOrdersControllerGetWorkOrderProgress>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getWorkOrdersControllerGetWorkOrderProgressQueryOptions(partnerName,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}

export const prefetchWorkOrdersControllerGetWorkOrderProgressQuery = async <TData = Awaited<ReturnType<typeof workOrdersControllerGetWorkOrderProgress>>, TError = unknown>(
 queryClient: QueryClient, partnerName: string,
    params?: WorkOrdersControllerGetWorkOrderProgressParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof workOrdersControllerGetWorkOrderProgress>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}

  ): Promise<QueryClient> => {

  const queryOptions = getWorkOrdersControllerGetWorkOrderProgressQueryOptions(partnerName,params,options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}



export const getWorkOrdersControllerGetWorkOrderProgressSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof workOrdersControllerGetWorkOrderProgress>>, TError = unknown>(partnerName: string,
    params?: WorkOrdersControllerGetWorkOrderProgressParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof workOrdersControllerGetWorkOrderProgress>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getWorkOrdersControllerGetWorkOrderProgressQueryKey(partnerName,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof workOrdersControllerGetWorkOrderProgress>>> = ({ signal }) => workOrdersControllerGetWorkOrderProgress(partnerName,params, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof workOrdersControllerGetWorkOrderProgress>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type WorkOrdersControllerGetWorkOrderProgressSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof workOrdersControllerGetWorkOrderProgress>>>
export type WorkOrdersControllerGetWorkOrderProgressSuspenseQueryError = unknown


export function useWorkOrdersControllerGetWorkOrderProgressSuspense<TData = Awaited<ReturnType<typeof workOrdersControllerGetWorkOrderProgress>>, TError = unknown>(
 partnerName: string,
    params: undefined |  WorkOrdersControllerGetWorkOrderProgressParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof workOrdersControllerGetWorkOrderProgress>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useWorkOrdersControllerGetWorkOrderProgressSuspense<TData = Awaited<ReturnType<typeof workOrdersControllerGetWorkOrderProgress>>, TError = unknown>(
 partnerName: string,
    params?: WorkOrdersControllerGetWorkOrderProgressParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof workOrdersControllerGetWorkOrderProgress>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useWorkOrdersControllerGetWorkOrderProgressSuspense<TData = Awaited<ReturnType<typeof workOrdersControllerGetWorkOrderProgress>>, TError = unknown>(
 partnerName: string,
    params?: WorkOrdersControllerGetWorkOrderProgressParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof workOrdersControllerGetWorkOrderProgress>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useWorkOrdersControllerGetWorkOrderProgressSuspense<TData = Awaited<ReturnType<typeof workOrdersControllerGetWorkOrderProgress>>, TError = unknown>(
 partnerName: string,
    params?: WorkOrdersControllerGetWorkOrderProgressParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof workOrdersControllerGetWorkOrderProgress>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient 
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getWorkOrdersControllerGetWorkOrderProgressSuspenseQueryOptions(partnerName,params,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Returns every non-archived work order for the partner with the same enriched shape the project planning grid uses (project / factory / product / container_selections / metadata).
 * @summary List all work orders for a partner
 */
export type workOrdersPartnerControllerListPartnerWorkOrdersResponse200 = {
  data: PartnerWorkOrderRowDto[]
  status: 200
}

export type workOrdersPartnerControllerListPartnerWorkOrdersResponse401 = {
  data: void
  status: 401
}

export type workOrdersPartnerControllerListPartnerWorkOrdersResponse403 = {
  data: void
  status: 403
}
    
export type workOrdersPartnerControllerListPartnerWorkOrdersResponseSuccess = (workOrdersPartnerControllerListPartnerWorkOrdersResponse200) & {
  headers: Headers;
};
export type workOrdersPartnerControllerListPartnerWorkOrdersResponseError = (workOrdersPartnerControllerListPartnerWorkOrdersResponse401 | workOrdersPartnerControllerListPartnerWorkOrdersResponse403) & {
  headers: Headers;
};

export type workOrdersPartnerControllerListPartnerWorkOrdersResponse = (workOrdersPartnerControllerListPartnerWorkOrdersResponseSuccess | workOrdersPartnerControllerListPartnerWorkOrdersResponseError)

export const getWorkOrdersPartnerControllerListPartnerWorkOrdersUrl = (partnerId: string,) => {


  

  return `/partners/${partnerId}/work-orders`
}

export const workOrdersPartnerControllerListPartnerWorkOrders = async (partnerId: string, options?: RequestInit): Promise<workOrdersPartnerControllerListPartnerWorkOrdersResponse> => {
  
  return customFetch<workOrdersPartnerControllerListPartnerWorkOrdersResponse>(getWorkOrdersPartnerControllerListPartnerWorkOrdersUrl(partnerId),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getWorkOrdersPartnerControllerListPartnerWorkOrdersQueryKey = (partnerId?: string,) => {
    return [
    `/partners/${partnerId}/work-orders`
    ] as const;
    }

    
export const getWorkOrdersPartnerControllerListPartnerWorkOrdersQueryOptions = <TData = Awaited<ReturnType<typeof workOrdersPartnerControllerListPartnerWorkOrders>>, TError = void>(partnerId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof workOrdersPartnerControllerListPartnerWorkOrders>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getWorkOrdersPartnerControllerListPartnerWorkOrdersQueryKey(partnerId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof workOrdersPartnerControllerListPartnerWorkOrders>>> = ({ signal }) => workOrdersPartnerControllerListPartnerWorkOrders(partnerId, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, enabled: !!(partnerId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof workOrdersPartnerControllerListPartnerWorkOrders>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type WorkOrdersPartnerControllerListPartnerWorkOrdersQueryResult = NonNullable<Awaited<ReturnType<typeof workOrdersPartnerControllerListPartnerWorkOrders>>>
export type WorkOrdersPartnerControllerListPartnerWorkOrdersQueryError = void


export function useWorkOrdersPartnerControllerListPartnerWorkOrders<TData = Awaited<ReturnType<typeof workOrdersPartnerControllerListPartnerWorkOrders>>, TError = void>(
 partnerId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof workOrdersPartnerControllerListPartnerWorkOrders>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof workOrdersPartnerControllerListPartnerWorkOrders>>,
          TError,
          Awaited<ReturnType<typeof workOrdersPartnerControllerListPartnerWorkOrders>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useWorkOrdersPartnerControllerListPartnerWorkOrders<TData = Awaited<ReturnType<typeof workOrdersPartnerControllerListPartnerWorkOrders>>, TError = void>(
 partnerId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof workOrdersPartnerControllerListPartnerWorkOrders>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof workOrdersPartnerControllerListPartnerWorkOrders>>,
          TError,
          Awaited<ReturnType<typeof workOrdersPartnerControllerListPartnerWorkOrders>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useWorkOrdersPartnerControllerListPartnerWorkOrders<TData = Awaited<ReturnType<typeof workOrdersPartnerControllerListPartnerWorkOrders>>, TError = void>(
 partnerId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof workOrdersPartnerControllerListPartnerWorkOrders>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary List all work orders for a partner
 */

export function useWorkOrdersPartnerControllerListPartnerWorkOrders<TData = Awaited<ReturnType<typeof workOrdersPartnerControllerListPartnerWorkOrders>>, TError = void>(
 partnerId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof workOrdersPartnerControllerListPartnerWorkOrders>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getWorkOrdersPartnerControllerListPartnerWorkOrdersQueryOptions(partnerId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}

/**
 * @summary List all work orders for a partner
 */
export const prefetchWorkOrdersPartnerControllerListPartnerWorkOrdersQuery = async <TData = Awaited<ReturnType<typeof workOrdersPartnerControllerListPartnerWorkOrders>>, TError = void>(
 queryClient: QueryClient, partnerId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof workOrdersPartnerControllerListPartnerWorkOrders>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}

  ): Promise<QueryClient> => {

  const queryOptions = getWorkOrdersPartnerControllerListPartnerWorkOrdersQueryOptions(partnerId,options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}



export const getWorkOrdersPartnerControllerListPartnerWorkOrdersSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof workOrdersPartnerControllerListPartnerWorkOrders>>, TError = void>(partnerId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof workOrdersPartnerControllerListPartnerWorkOrders>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getWorkOrdersPartnerControllerListPartnerWorkOrdersQueryKey(partnerId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof workOrdersPartnerControllerListPartnerWorkOrders>>> = ({ signal }) => workOrdersPartnerControllerListPartnerWorkOrders(partnerId, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof workOrdersPartnerControllerListPartnerWorkOrders>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type WorkOrdersPartnerControllerListPartnerWorkOrdersSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof workOrdersPartnerControllerListPartnerWorkOrders>>>
export type WorkOrdersPartnerControllerListPartnerWorkOrdersSuspenseQueryError = void


export function useWorkOrdersPartnerControllerListPartnerWorkOrdersSuspense<TData = Awaited<ReturnType<typeof workOrdersPartnerControllerListPartnerWorkOrders>>, TError = void>(
 partnerId: string, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof workOrdersPartnerControllerListPartnerWorkOrders>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useWorkOrdersPartnerControllerListPartnerWorkOrdersSuspense<TData = Awaited<ReturnType<typeof workOrdersPartnerControllerListPartnerWorkOrders>>, TError = void>(
 partnerId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof workOrdersPartnerControllerListPartnerWorkOrders>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useWorkOrdersPartnerControllerListPartnerWorkOrdersSuspense<TData = Awaited<ReturnType<typeof workOrdersPartnerControllerListPartnerWorkOrders>>, TError = void>(
 partnerId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof workOrdersPartnerControllerListPartnerWorkOrders>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary List all work orders for a partner
 */

export function useWorkOrdersPartnerControllerListPartnerWorkOrdersSuspense<TData = Awaited<ReturnType<typeof workOrdersPartnerControllerListPartnerWorkOrders>>, TError = void>(
 partnerId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof workOrdersPartnerControllerListPartnerWorkOrders>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient 
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getWorkOrdersPartnerControllerListPartnerWorkOrdersSuspenseQueryOptions(partnerId,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Flips work_orders.is_redrafting = true for every supplied work_order_id that currently belongs to the path partner and is in 'scheduled' or 'redrafting'. The trigger on work_orders recomputes work_order_current_status to 'redrafting'. Idempotent: ids already in 'redrafting' are reported in `unchanged` rather than treated as an error.
 * @summary Reopen released work orders for system-column edits
 */
export type workOrdersPartnerControllerReopenForEditResponse201 = {
  data: WorkOrderStatusTransitionResponseDto
  status: 201
}

export type workOrdersPartnerControllerReopenForEditResponse400 = {
  data: void
  status: 400
}

export type workOrdersPartnerControllerReopenForEditResponse401 = {
  data: void
  status: 401
}

export type workOrdersPartnerControllerReopenForEditResponse403 = {
  data: void
  status: 403
}

export type workOrdersPartnerControllerReopenForEditResponse404 = {
  data: void
  status: 404
}
    
export type workOrdersPartnerControllerReopenForEditResponseSuccess = (workOrdersPartnerControllerReopenForEditResponse201) & {
  headers: Headers;
};
export type workOrdersPartnerControllerReopenForEditResponseError = (workOrdersPartnerControllerReopenForEditResponse400 | workOrdersPartnerControllerReopenForEditResponse401 | workOrdersPartnerControllerReopenForEditResponse403 | workOrdersPartnerControllerReopenForEditResponse404) & {
  headers: Headers;
};

export type workOrdersPartnerControllerReopenForEditResponse = (workOrdersPartnerControllerReopenForEditResponseSuccess | workOrdersPartnerControllerReopenForEditResponseError)

export const getWorkOrdersPartnerControllerReopenForEditUrl = (partnerId: string,) => {


  

  return `/partners/${partnerId}/work-orders/reopen-for-edit`
}

export const workOrdersPartnerControllerReopenForEdit = async (partnerId: string,
    workOrderStatusTransitionDto: WorkOrderStatusTransitionDto, options?: RequestInit): Promise<workOrdersPartnerControllerReopenForEditResponse> => {
  
  return customFetch<workOrdersPartnerControllerReopenForEditResponse>(getWorkOrdersPartnerControllerReopenForEditUrl(partnerId),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      workOrderStatusTransitionDto,)
  }
);}




export const getWorkOrdersPartnerControllerReopenForEditMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof workOrdersPartnerControllerReopenForEdit>>, TError,{partnerId: string;data: WorkOrderStatusTransitionDto}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof workOrdersPartnerControllerReopenForEdit>>, TError,{partnerId: string;data: WorkOrderStatusTransitionDto}, TContext> => {

const mutationKey = ['workOrdersPartnerControllerReopenForEdit'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof workOrdersPartnerControllerReopenForEdit>>, {partnerId: string;data: WorkOrderStatusTransitionDto}> = (props) => {
          const {partnerId,data} = props ?? {};

          return  workOrdersPartnerControllerReopenForEdit(partnerId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type WorkOrdersPartnerControllerReopenForEditMutationResult = NonNullable<Awaited<ReturnType<typeof workOrdersPartnerControllerReopenForEdit>>>
    export type WorkOrdersPartnerControllerReopenForEditMutationBody = WorkOrderStatusTransitionDto
    export type WorkOrdersPartnerControllerReopenForEditMutationError = void

    /**
 * @summary Reopen released work orders for system-column edits
 */
export const useWorkOrdersPartnerControllerReopenForEdit = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof workOrdersPartnerControllerReopenForEdit>>, TError,{partnerId: string;data: WorkOrderStatusTransitionDto}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof workOrdersPartnerControllerReopenForEdit>>,
        TError,
        {partnerId: string;data: WorkOrderStatusTransitionDto},
        TContext
      > => {

      const mutationOptions = getWorkOrdersPartnerControllerReopenForEditMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * Flips work_orders.is_redrafting = false for every supplied work_order_id that currently belongs to the path partner and is in 'redrafting' or 'scheduled'. The trigger recomputes status back to 'scheduled'. Does NOT create or roll a Bill of Operations version — that remains a separate flow under /change-control. Idempotent in the same way as reopen-for-edit.
 * @summary Re-release work orders previously reopened for edit
 */
export type workOrdersPartnerControllerReReleaseResponse201 = {
  data: WorkOrderStatusTransitionResponseDto
  status: 201
}

export type workOrdersPartnerControllerReReleaseResponse400 = {
  data: void
  status: 400
}

export type workOrdersPartnerControllerReReleaseResponse401 = {
  data: void
  status: 401
}

export type workOrdersPartnerControllerReReleaseResponse403 = {
  data: void
  status: 403
}

export type workOrdersPartnerControllerReReleaseResponse404 = {
  data: void
  status: 404
}
    
export type workOrdersPartnerControllerReReleaseResponseSuccess = (workOrdersPartnerControllerReReleaseResponse201) & {
  headers: Headers;
};
export type workOrdersPartnerControllerReReleaseResponseError = (workOrdersPartnerControllerReReleaseResponse400 | workOrdersPartnerControllerReReleaseResponse401 | workOrdersPartnerControllerReReleaseResponse403 | workOrdersPartnerControllerReReleaseResponse404) & {
  headers: Headers;
};

export type workOrdersPartnerControllerReReleaseResponse = (workOrdersPartnerControllerReReleaseResponseSuccess | workOrdersPartnerControllerReReleaseResponseError)

export const getWorkOrdersPartnerControllerReReleaseUrl = (partnerId: string,) => {


  

  return `/partners/${partnerId}/work-orders/re-release`
}

export const workOrdersPartnerControllerReRelease = async (partnerId: string,
    workOrderStatusTransitionDto: WorkOrderStatusTransitionDto, options?: RequestInit): Promise<workOrdersPartnerControllerReReleaseResponse> => {
  
  return customFetch<workOrdersPartnerControllerReReleaseResponse>(getWorkOrdersPartnerControllerReReleaseUrl(partnerId),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      workOrderStatusTransitionDto,)
  }
);}




export const getWorkOrdersPartnerControllerReReleaseMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof workOrdersPartnerControllerReRelease>>, TError,{partnerId: string;data: WorkOrderStatusTransitionDto}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof workOrdersPartnerControllerReRelease>>, TError,{partnerId: string;data: WorkOrderStatusTransitionDto}, TContext> => {

const mutationKey = ['workOrdersPartnerControllerReRelease'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof workOrdersPartnerControllerReRelease>>, {partnerId: string;data: WorkOrderStatusTransitionDto}> = (props) => {
          const {partnerId,data} = props ?? {};

          return  workOrdersPartnerControllerReRelease(partnerId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type WorkOrdersPartnerControllerReReleaseMutationResult = NonNullable<Awaited<ReturnType<typeof workOrdersPartnerControllerReRelease>>>
    export type WorkOrdersPartnerControllerReReleaseMutationBody = WorkOrderStatusTransitionDto
    export type WorkOrdersPartnerControllerReReleaseMutationError = void

    /**
 * @summary Re-release work orders previously reopened for edit
 */
export const useWorkOrdersPartnerControllerReRelease = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof workOrdersPartnerControllerReRelease>>, TError,{partnerId: string;data: WorkOrderStatusTransitionDto}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof workOrdersPartnerControllerReRelease>>,
        TError,
        {partnerId: string;data: WorkOrderStatusTransitionDto},
        TContext
      > => {

      const mutationOptions = getWorkOrdersPartnerControllerReReleaseMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * Moves the selected work orders within their Manufacturing Sequence Number running order. Every selected work order must belong to the path partner, be in a movable state (scheduled or redrafting), and share one running order: a single factory, or — for work orders without a factory — the partner-wide unassigned group. Started work (in_progress / complete) keeps its number and the movable run is renumbered contiguously after it; only rows whose number changes are written. Modes: by_number (the first selected work order lands on target_sequence_number), after / before (placed relative to anchor_work_order_code).
 * @summary Reorder the Manufacturing Sequence Number for one or more work orders
 */
export type workOrdersPartnerControllerReorderManufacturingSequenceResponse201 = {
  data: ReorderManufacturingSequenceResponseDto
  status: 201
}

export type workOrdersPartnerControllerReorderManufacturingSequenceResponse400 = {
  data: void
  status: 400
}

export type workOrdersPartnerControllerReorderManufacturingSequenceResponse401 = {
  data: void
  status: 401
}

export type workOrdersPartnerControllerReorderManufacturingSequenceResponse403 = {
  data: void
  status: 403
}

export type workOrdersPartnerControllerReorderManufacturingSequenceResponse404 = {
  data: void
  status: 404
}

export type workOrdersPartnerControllerReorderManufacturingSequenceResponse409 = {
  data: void
  status: 409
}
    
export type workOrdersPartnerControllerReorderManufacturingSequenceResponseSuccess = (workOrdersPartnerControllerReorderManufacturingSequenceResponse201) & {
  headers: Headers;
};
export type workOrdersPartnerControllerReorderManufacturingSequenceResponseError = (workOrdersPartnerControllerReorderManufacturingSequenceResponse400 | workOrdersPartnerControllerReorderManufacturingSequenceResponse401 | workOrdersPartnerControllerReorderManufacturingSequenceResponse403 | workOrdersPartnerControllerReorderManufacturingSequenceResponse404 | workOrdersPartnerControllerReorderManufacturingSequenceResponse409) & {
  headers: Headers;
};

export type workOrdersPartnerControllerReorderManufacturingSequenceResponse = (workOrdersPartnerControllerReorderManufacturingSequenceResponseSuccess | workOrdersPartnerControllerReorderManufacturingSequenceResponseError)

export const getWorkOrdersPartnerControllerReorderManufacturingSequenceUrl = (partnerId: string,) => {


  

  return `/partners/${partnerId}/work-orders/reorder-manufacturing-sequence`
}

export const workOrdersPartnerControllerReorderManufacturingSequence = async (partnerId: string,
    reorderManufacturingSequenceDto: ReorderManufacturingSequenceDto, options?: RequestInit): Promise<workOrdersPartnerControllerReorderManufacturingSequenceResponse> => {
  
  return customFetch<workOrdersPartnerControllerReorderManufacturingSequenceResponse>(getWorkOrdersPartnerControllerReorderManufacturingSequenceUrl(partnerId),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      reorderManufacturingSequenceDto,)
  }
);}




export const getWorkOrdersPartnerControllerReorderManufacturingSequenceMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof workOrdersPartnerControllerReorderManufacturingSequence>>, TError,{partnerId: string;data: ReorderManufacturingSequenceDto}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof workOrdersPartnerControllerReorderManufacturingSequence>>, TError,{partnerId: string;data: ReorderManufacturingSequenceDto}, TContext> => {

const mutationKey = ['workOrdersPartnerControllerReorderManufacturingSequence'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof workOrdersPartnerControllerReorderManufacturingSequence>>, {partnerId: string;data: ReorderManufacturingSequenceDto}> = (props) => {
          const {partnerId,data} = props ?? {};

          return  workOrdersPartnerControllerReorderManufacturingSequence(partnerId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type WorkOrdersPartnerControllerReorderManufacturingSequenceMutationResult = NonNullable<Awaited<ReturnType<typeof workOrdersPartnerControllerReorderManufacturingSequence>>>
    export type WorkOrdersPartnerControllerReorderManufacturingSequenceMutationBody = ReorderManufacturingSequenceDto
    export type WorkOrdersPartnerControllerReorderManufacturingSequenceMutationError = void

    /**
 * @summary Reorder the Manufacturing Sequence Number for one or more work orders
 */
export const useWorkOrdersPartnerControllerReorderManufacturingSequence = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof workOrdersPartnerControllerReorderManufacturingSequence>>, TError,{partnerId: string;data: ReorderManufacturingSequenceDto}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof workOrdersPartnerControllerReorderManufacturingSequence>>,
        TError,
        {partnerId: string;data: ReorderManufacturingSequenceDto},
        TContext
      > => {

      const mutationOptions = getWorkOrdersPartnerControllerReorderManufacturingSequenceMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * Returns every job card materialised for the work order, ordered by job_card_order. Used by the Work Orders grid as a master/detail child table.
 * @summary List a work order's job cards
 */
export type workOrdersPartnerControllerListJobCardsResponse200 = {
  data: JobCardRowDto[]
  status: 200
}

export type workOrdersPartnerControllerListJobCardsResponse401 = {
  data: void
  status: 401
}

export type workOrdersPartnerControllerListJobCardsResponse403 = {
  data: void
  status: 403
}

export type workOrdersPartnerControllerListJobCardsResponse404 = {
  data: void
  status: 404
}
    
export type workOrdersPartnerControllerListJobCardsResponseSuccess = (workOrdersPartnerControllerListJobCardsResponse200) & {
  headers: Headers;
};
export type workOrdersPartnerControllerListJobCardsResponseError = (workOrdersPartnerControllerListJobCardsResponse401 | workOrdersPartnerControllerListJobCardsResponse403 | workOrdersPartnerControllerListJobCardsResponse404) & {
  headers: Headers;
};

export type workOrdersPartnerControllerListJobCardsResponse = (workOrdersPartnerControllerListJobCardsResponseSuccess | workOrdersPartnerControllerListJobCardsResponseError)

export const getWorkOrdersPartnerControllerListJobCardsUrl = (workOrderId: string,) => {


  

  return `/work-orders/${workOrderId}/job-cards`
}

export const workOrdersPartnerControllerListJobCards = async (workOrderId: string, options?: RequestInit): Promise<workOrdersPartnerControllerListJobCardsResponse> => {
  
  return customFetch<workOrdersPartnerControllerListJobCardsResponse>(getWorkOrdersPartnerControllerListJobCardsUrl(workOrderId),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getWorkOrdersPartnerControllerListJobCardsQueryKey = (workOrderId?: string,) => {
    return [
    `/work-orders/${workOrderId}/job-cards`
    ] as const;
    }

    
export const getWorkOrdersPartnerControllerListJobCardsQueryOptions = <TData = Awaited<ReturnType<typeof workOrdersPartnerControllerListJobCards>>, TError = void>(workOrderId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof workOrdersPartnerControllerListJobCards>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getWorkOrdersPartnerControllerListJobCardsQueryKey(workOrderId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof workOrdersPartnerControllerListJobCards>>> = ({ signal }) => workOrdersPartnerControllerListJobCards(workOrderId, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, enabled: !!(workOrderId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof workOrdersPartnerControllerListJobCards>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type WorkOrdersPartnerControllerListJobCardsQueryResult = NonNullable<Awaited<ReturnType<typeof workOrdersPartnerControllerListJobCards>>>
export type WorkOrdersPartnerControllerListJobCardsQueryError = void


export function useWorkOrdersPartnerControllerListJobCards<TData = Awaited<ReturnType<typeof workOrdersPartnerControllerListJobCards>>, TError = void>(
 workOrderId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof workOrdersPartnerControllerListJobCards>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof workOrdersPartnerControllerListJobCards>>,
          TError,
          Awaited<ReturnType<typeof workOrdersPartnerControllerListJobCards>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useWorkOrdersPartnerControllerListJobCards<TData = Awaited<ReturnType<typeof workOrdersPartnerControllerListJobCards>>, TError = void>(
 workOrderId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof workOrdersPartnerControllerListJobCards>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof workOrdersPartnerControllerListJobCards>>,
          TError,
          Awaited<ReturnType<typeof workOrdersPartnerControllerListJobCards>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useWorkOrdersPartnerControllerListJobCards<TData = Awaited<ReturnType<typeof workOrdersPartnerControllerListJobCards>>, TError = void>(
 workOrderId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof workOrdersPartnerControllerListJobCards>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary List a work order's job cards
 */

export function useWorkOrdersPartnerControllerListJobCards<TData = Awaited<ReturnType<typeof workOrdersPartnerControllerListJobCards>>, TError = void>(
 workOrderId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof workOrdersPartnerControllerListJobCards>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getWorkOrdersPartnerControllerListJobCardsQueryOptions(workOrderId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}

/**
 * @summary List a work order's job cards
 */
export const prefetchWorkOrdersPartnerControllerListJobCardsQuery = async <TData = Awaited<ReturnType<typeof workOrdersPartnerControllerListJobCards>>, TError = void>(
 queryClient: QueryClient, workOrderId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof workOrdersPartnerControllerListJobCards>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}

  ): Promise<QueryClient> => {

  const queryOptions = getWorkOrdersPartnerControllerListJobCardsQueryOptions(workOrderId,options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}



export const getWorkOrdersPartnerControllerListJobCardsSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof workOrdersPartnerControllerListJobCards>>, TError = void>(workOrderId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof workOrdersPartnerControllerListJobCards>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getWorkOrdersPartnerControllerListJobCardsQueryKey(workOrderId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof workOrdersPartnerControllerListJobCards>>> = ({ signal }) => workOrdersPartnerControllerListJobCards(workOrderId, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof workOrdersPartnerControllerListJobCards>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type WorkOrdersPartnerControllerListJobCardsSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof workOrdersPartnerControllerListJobCards>>>
export type WorkOrdersPartnerControllerListJobCardsSuspenseQueryError = void


export function useWorkOrdersPartnerControllerListJobCardsSuspense<TData = Awaited<ReturnType<typeof workOrdersPartnerControllerListJobCards>>, TError = void>(
 workOrderId: string, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof workOrdersPartnerControllerListJobCards>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useWorkOrdersPartnerControllerListJobCardsSuspense<TData = Awaited<ReturnType<typeof workOrdersPartnerControllerListJobCards>>, TError = void>(
 workOrderId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof workOrdersPartnerControllerListJobCards>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useWorkOrdersPartnerControllerListJobCardsSuspense<TData = Awaited<ReturnType<typeof workOrdersPartnerControllerListJobCards>>, TError = void>(
 workOrderId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof workOrdersPartnerControllerListJobCards>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary List a work order's job cards
 */

export function useWorkOrdersPartnerControllerListJobCardsSuspense<TData = Awaited<ReturnType<typeof workOrdersPartnerControllerListJobCards>>, TError = void>(
 workOrderId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof workOrdersPartnerControllerListJobCards>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient 
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getWorkOrdersPartnerControllerListJobCardsSuspenseQueryOptions(workOrderId,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




